module.exports = __webpack_public_path__ + "media/pages/book/components/images/app-reviews/en/vanessa-377e24a7fb8d78d91fe1bf3d225ca701.jpg";